if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

      connectedCallback() {

        this.truemedUpdateAppMessage()
        this.moveTruemedInstructions()

      }

    onSubmitHandler(evt) {

      evt.preventDefault();

      if(this.querySelectorAll('[required][name^="properties"]:not(:disabled)').length > 0){
        const propertiesRequired = this.querySelectorAll('[required][name^="properties"]:not(:disabled)');
        const hasEmptyField = Array.from(propertiesRequired).some(el => !el.disabled && !el.value.trim());
        
        if (hasEmptyField) {
            propertiesRequired.forEach(item => {
              !item.disabled && item.value.length === 0 ? item.classList.add('error') : item.classList.remove('error')
            });
            return false;
        }else{
          propertiesRequired.forEach(item => {
            item.classList.remove('error')
          });
        }
      
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('free')
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            document.querySelector('.ajax-add-notice').classList.add('hidden')
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            //window.location = routes_cart_url;
            return;
          }
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            document.querySelector('.ajax-add-notice').classList.remove('hidden')
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const drawerCart = document.querySelector('cart-drawer');
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (!drawerCart) {
            window.location = routes_cart_url;
          }
          updateCartCounterHeader();
        });
    }
 
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (errorMessage.email) {
          this.emailErrorMessage = this.querySelector('.recipient-form__email-error-message-wrapper .product-form__error-message');
          if (!this.emailErrorMessage) return;
          this.emailErrorMessage.parentNode.toggleAttribute('hidden', !errorMessage);
          this.emailErrorMessage.textContent = errorMessage.email;
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }


      truemedUpdateAppMessage(){
       
        function waitForElement(selector, callback, timeout = 10000) {
          const element = document.querySelector(selector);
          if (element) {
            callback(element);
            return;
          }

          const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
              observer.disconnect();
              callback(el);
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });

          setTimeout(() => {
            observer.disconnect();
          
          }, timeout);
        }
        waitForElement('.truemed-entry-box', (el) => {
            const target = el.querySelector('.truemed-entry-logo + .truemed-entry-text');
              if(!target) return
              const getTrumedButton = el.querySelector('button.truemed-instructions-open');
              if(!getTrumedButton) return
              target.style.display = 'none';
              getTrumedButton.innerHTML = target.textContent.replace('an average of',' ')
        });

      }

      moveTruemedInstructions(){
        
        const truemedInstructions = this.querySelector('.truemed-instructions');
        if (truemedInstructions) {
          this.moveElement(truemedInstructions);
          // add custom HTML for HSA/FSA
          this.insertHSAFSAElement(truemedInstructions);
          return;
        }

        // if element is not appeared, track changes in DOM
        const observer = new MutationObserver((mutations) => {
          const truemedEl = this.querySelector('.truemed-instructions');
          if (truemedEl) {
            observer.disconnect();
            this.moveElement(truemedEl);
            // add custom HTML for HSA/FSA
            this.insertHSAFSAElement(truemedEl);
          }
        });

        observer.observe(this, {
          childList: true,
          subtree: true,
        });

        // stop tracking after 10 seconds
        setTimeout(() => {
          observer.disconnect();
        }, 10000);
      }

      moveElement(truemedElement) {
        // move only on resolutions more than 768px
        if (window.innerWidth <= 768) return;

        if (!truemedElement) return;

        // check if element is already moved
        if (truemedElement.dataset.moved === 'true') return;

        // find element with class .short-description or .product-tabs-content
        // search within product-form context first, then globally
        const shortDescription = this.querySelector('.short-description') || document.querySelector('.short-description');
        const productTabsContent = this.querySelector('.product-tabs-content') || document.querySelector('.product-tabs-content');
        const titlePriceRow = this.querySelector('.title-price-row') || document.querySelector('.title-price-row');
        let targetElement = null;
        let insertMethod = 'afterend'; // default: insert after element
        let productforms = this.querySelector('.pdp-tabs') || document.querySelector('.pdp-tabs');
        if (productforms) {
          targetElement = productforms;
          insertMethod = 'beforeend';
        } else if (shortDescription) {
          targetElement = shortDescription;
        } else if (productTabsContent && titlePriceRow) {
          // if both productTabsContent and titlePriceRow exist, insert after titlePriceRow
          targetElement = titlePriceRow;
        } else if (productTabsContent) {
          targetElement = productTabsContent;
        } else if (titlePriceRow) {
          // if neither shortDescription nor productTabsContent found, insert after title-price-row
          targetElement = titlePriceRow;
        } else {
          // if neither found, insert after the form, but inside product-form
          if (this.form) {
            targetElement = this.form;
            insertMethod = 'afterend'; // insert after form element, inside product-form
          } else {
            // fallback: insert at the end of product-form
            targetElement = this;
            insertMethod = 'beforeend';
          }
        }
        if (!targetElement) return;

        // cut element from current place and insert
        truemedElement.remove();
        if (insertMethod === 'beforeend') {
          targetElement.appendChild(truemedElement);
        } else {
          targetElement.insertAdjacentElement(insertMethod, truemedElement);
        }
        truemedElement.dataset.moved = 'true';
      }

      insertHSAFSAElement(truemedElement) {
        // check if element is already inserted
        if (truemedElement.querySelector('.hsafsa-badge')) return;

        // find .truemed-entry-box inside .truemed-instructions
        const truemedEntryBox = truemedElement.querySelector('.truemed-entry-box');
        
        if (truemedEntryBox) {
          // if element is already exists, insert it immediately
          this.createAndInsertHSAFSA(truemedEntryBox);
        } else {
          // if element is not appeared, track its appearance
          const observer = new MutationObserver(() => {
            const entryBox = truemedElement.querySelector('.truemed-entry-box');
            if (entryBox) {
              observer.disconnect();
              this.createAndInsertHSAFSA(entryBox);
            }
          });

          observer.observe(truemedElement, {
            childList: true,
            subtree: true,
          });

          setTimeout(() => {
            observer.disconnect();
          }, 10000);
        }
      }

      createAndInsertHSAFSA(truemedEntryBox) {
        // check if custom HTML is already inserted
        if (truemedEntryBox.parentElement.querySelector('.hsafsa-badge')) return;

        // create custom HTML
        const hsafsaBadge = document.createElement('div');
        hsafsaBadge.className = 'hsafsa-badge';
        hsafsaBadge.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="27" viewBox="0 0 32 27" fill="none">
            <path d="M16.0089 25.0806C14.56 25.0806 13.1111 24.8317 11.7422 24.325C9.2711 23.4094 7.12888 21.7028 5.69777 19.4983C4.26666 17.2939 3.57333 14.645 3.74221 12.0228C3.9111 9.40056 4.9511 6.85834 6.66666 4.86723C8.37333 2.86723 10.7289 1.45389 13.2889 0.876115C15.8489 0.298337 18.5867 0.565004 20.9955 1.63167C21.5644 1.88056 21.8044 2.53834 21.5644 3.10723C21.3067 3.67611 20.6578 3.925 20.0889 3.67611C18.1244 2.79611 15.8844 2.58278 13.7867 3.05389C11.6889 3.53389 9.75999 4.68945 8.36444 6.31611C6.95999 7.94278 6.12444 10.0228 5.98221 12.165C5.83999 14.3072 6.40888 16.4761 7.57333 18.2806C8.74666 20.0761 10.5067 21.4894 12.5244 22.2272C14.5422 22.9739 16.7911 23.045 18.8533 22.4317C20.9155 21.8183 22.7644 20.5383 24.0444 18.8228C25.3333 17.1072 26.0444 14.9739 26.0444 12.8228V11.8006C26.0444 11.1872 26.5422 10.6894 27.1644 10.6894C27.7867 10.6894 28.2844 11.1872 28.2844 11.8006V12.8228C28.2844 15.445 27.4133 18.0494 25.84 20.1561C24.2667 22.2628 22.0089 23.8183 19.4933 24.565C18.3644 24.9028 17.1911 25.0628 16.0089 25.0628V25.0806Z" fill="#93D4E9"/>
            <path d="M15.9999 16.1917C15.6977 16.1917 15.4221 16.0761 15.2088 15.8628L11.8577 12.5205C11.4221 12.085 11.4221 11.3828 11.8577 10.9472C12.2932 10.5117 12.9955 10.5117 13.4399 10.9472L15.9999 13.4983L26.3732 3.14277C26.8088 2.70721 27.511 2.70721 27.9555 3.14277C28.391 3.57832 28.391 4.28055 27.9555 4.7161L16.791 15.8628C16.5866 16.0672 16.3021 16.1917 15.9999 16.1917Z" fill="#1E6484"/>
          </svg>
          <div class="hsafsa-content">
            <div class="hsafsa-title">HSA/FSA
            <div class="hsafsa-subtitle">Eligible</div>
            </div>
            </div>
        `;

        // insert before .truemed-entry-box
        truemedEntryBox.insertAdjacentElement('beforebegin', hsafsaBadge);
      }
  });
}

